<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon fontIcon="settings_remote"></mat-icon>
        {{'settings.project.kyd_reports' | translate}}
        <!-- <app-help [link]="helpLink" class="helper-margin"></app-help> -->
    </h1>
    <span class="toolbar-spacer"></span>
</mat-toolbar>

<mat-tab-group class="mat-tab-group kyd-view-tabs">
    <!-- Reports -->
    <mat-tab>
        <ng-template mat-tab-label>
            <div class="tab-label">
                <mat-icon fontIcon="description"></mat-icon>
                {{'settings.project.kyd_reports_tab' | translate}}
            </div>
        </ng-template>

        <div class="filter reports-filter-row">
    <mat-form-field appearance="outline" size="small">
        <mat-label>Filter</mat-label>
        <input matInput [(ngModel)]="reportSearchText" (ngModelChange)="applyCombinedFilter()"
            placeholder="Ex: {{ 'datatable.modify_kyd_values' | translate }}" />
    </mat-form-field>

    <mat-form-field appearance="outline" size="small">
        <mat-label>{{'datatable.createdDate'|translate}}</mat-label>
        <input matInput [matDatepicker]="reportDatePicker" [(ngModel)]="reportDateFilter"
            (dateChange)="applyCombinedFilter()">
        <mat-icon matIconSuffix *ngIf="reportDateFilter" (click)="clearDateFilter()" class="clear-date-icon">
            close</mat-icon>
        <mat-datepicker-toggle matIconSuffix [for]="reportDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #reportDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" size="small">
        <mat-label>{{'datatable.sort_order'|translate}}</mat-label>
        <mat-select [(value)]="reportSortOrder" (selectionChange)="onSortOrderChange($event.value)">
            <mat-option value="desc">{{'datatable.sort_recent_first'|translate}}</mat-option>
            <mat-option value="asc">{{'datatable.sort_oldest_first'|translate}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div class="table-container">
<table mat-table [dataSource]="kydSource" matSort class="mat-elevation-z8">
    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "datatable.type" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
    </ng-container>

    <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "datatable.createdDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.createdDate }}</td>
    </ng-container>

    <ng-container matColumnDef="devices">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "datatable.devices" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
            {{ row.successDevices }}/{{ row.logs.length }}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
            {{ "datatable.action" | translate }}
        </th>
        <!-- No "view details" button here - clicking the row itself already opens the report
        (see matRowDef below), so a separate eye icon just duplicated that. -->
        <td mat-cell *matCellDef="let element; let index = index" class="spaced-button" (click)="$event.stopPropagation()">
            <lib-button color="none" textColor="danger" icon="delete" [tooltip]="'datatable.delete'|translate"
                (click)="deleteReport(element)"></lib-button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="clickable-row" (click)="viewReport(row)"></tr>

    <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
            </lib-no-data>
        </td>
    </tr>
</table>

<mat-paginator #reportsPaginator [length]="reports.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]"
    class="paginator">
</mat-paginator>
</div>
    </mat-tab>

    <!-- KYD list -->
    <mat-tab>
        <ng-template mat-tab-label>
            <div class="tab-label">
                <mat-icon fontIcon="sensors"></mat-icon>
                {{'settings.project.kyd_list_tab' | translate}}
            </div>
        </ng-template>

        <mat-toolbar class="content-header">
            <span class="toolbar-spacer"></span>
            <lib-button [color]="multiSelectMode ? 'primary' : 'secondary'" icon="checklist"
                [tooltip]="(multiSelectMode ? 'trackers.cancel_multi_select' : 'trackers.multi_select') | translate"
                (click)="toggleMultiSelectMode()"></lib-button>
            <lib-button color="primary" icon="add" [tooltip]="'trackers.addTracker'|translate"
                (click)="openAddKydDialog()"></lib-button>
        </mat-toolbar>

        <div class="filter kyd-filter-row" *ngIf="kydTrackers.length">
    <mat-form-field appearance="outline" size="small">
        <mat-label>Filter</mat-label>
        <input matInput [(ngModel)]="kydTrackerFilter" placeholder="Ex: FAKE KYD 1" />
    </mat-form-field>

    <mat-checkbox *ngIf="multiSelectMode && filteredKydTrackers.length" [checked]="allVisibleKydSelected"
        (change)="toggleSelectAllKyd()">{{'trackers.select_all_kyd'|translate}}</mat-checkbox>

    <div class="bulk-actions" *ngIf="multiSelectMode && selectedKydTrackers.length">
        <span class="bulk-selection-count">{{ selectedKydTrackers.length }} {{'trackers.selected'|translate}}</span>
        <lib-button color="secondary" icon="settings" text="{{'trackers.configure_selection'|translate}}"
            (click)="bulkConfigureKyd()"></lib-button>
        <lib-button color="secondary" icon="bookmark" text="{{'trackers.apply_template_selection'|translate}}"
            (click)="bulkApplyTemplateDirectly()"></lib-button>
        <lib-button color="none" textColor="danger" icon="delete" text="{{'trackers.delete_selection'|translate}}"
            (click)="bulkDeleteKyd()"></lib-button>
    </div>
</div>

<lib-no-data *ngIf="!kydTrackers.length" message="trackers.no_kyd_tracker" icon="sensors_off"></lib-no-data>
<lib-no-data *ngIf="kydTrackers.length && !filteredKydTrackers.length" message="form.search_no_data"
    description="form.search_no_data_desc" icon="search_off"></lib-no-data>

<div class="kyd-config-grid">
    <mat-card *ngFor="let tracker of filteredKydTrackers" class="kyd-config-card"
        [class.with-checkbox]="multiSelectMode">
        <mat-card-header>
            <mat-checkbox *ngIf="multiSelectMode" class="kyd-card-checkbox"
                [(ngModel)]="tracker.selected"></mat-checkbox>
            <mat-card-title>{{ tracker.name }}</mat-card-title>
            <div class="kyd-card-actions">
                <lib-button color="none" textColor="secondary" icon="edit" [tooltip]="'form.edit'|translate"
                    (click)="editKydTracker(tracker)"></lib-button>
                <lib-button color="none" textColor="danger" icon="delete" [tooltip]="'datatable.delete'|translate"
                    (click)="deleteKydTracker(tracker)"></lib-button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <p *ngIf="appliedConfigName(tracker)" class="applied-template-line">
                {{'menu.devices.configs.applied_template'|translate}}: {{appliedConfigName(tracker)}}
            </p>
            <div *ngIf="kydConfigTool.isConnecting(tracker)" class="info-banner warn-banner">
                <mat-icon>bluetooth_searching</mat-icon>
                <span>{{'trackers.connecting_status'|translate}}</span>
            </div>

            <!-- Only meaningful once there's something to have confirmed - a brand new tracker
            with no settings at all yet has neither received nor failed to receive anything. -->
            <div *ngIf="hasKydSettings(tracker)" class="info-banner"
                [ngClass]="tracker.settingsConfirmed ? 'success-banner' : 'warn-banner'">
                <mat-icon>{{tracker.settingsConfirmed ? 'check_circle' : 'help'}}</mat-icon>
                <span>{{ (tracker.settingsConfirmed ? 'units.device.settings_confirmed' : 'units.device.settings_not_confirmed') | translate }}</span>
            </div>

            <p *ngIf="!hasKydSettings(tracker)" class="not-configured">
                {{'trackers.kyd_not_configured'|translate}}
            </p>

            <ng-container *ngIf="hasKydSettings(tracker)">
                <!-- Unset on trackers saved before this distinction existed, or from other
                tools that don't set it - nothing meaningful to show for those. -->
                <p class="p-flex" *ngIf="displayUserMode(tracker)">
                    <mat-icon color="primary" class="mr-1">tune</mat-icon>
                    {{'units.device.mode'|translate}} : {{ (displayUserMode(tracker) === 'advanced' ? 'units.device.mode_advanced' : 'units.device.mode_easy') | translate }}
                </p>

                <h4 class="p-flex">
                    <mat-icon class="header-icon-card">straighten</mat-icon>
                    {{'trackers.distances'|translate}}
                </h4>
                <!-- Simple mode on the mobile app only ever configures unfriendDistance
                (distance de désappareillage) - minDistance/maxDistance stay whatever they
                already were (typically from a previous Advanced-mode save), completely
                independent of it (see ble-detail.page.ts/tracker-config-form.component.ts).
                `userMode` is unset on trackers saved before this distinction existed, or from
                other tools (e.g. the config editor in Ressources > Dispositif) - those keep
                showing everything, as before; only a tracker explicitly tagged 'easy' collapses
                down to the single field below. -->
                <ng-container *ngIf="displayUserMode(tracker) !== 'easy'">
                    <p class="p-flex">
                        <mat-icon color="primary" class="mr-1">swap_calls</mat-icon>
                        {{'trackers.selfAlertDistance'|translate}} : {{formatDistance(displayMinDistance(tracker))}} m
                    </p>
                    <p class="p-flex">
                        <mat-icon color="primary" class="mr-1">swap_calls</mat-icon>
                        {{'trackers.otherAlertDistance'|translate}} : {{formatDistance(displayMaxDistance(tracker))}} m
                    </p>
                </ng-container>
                <p class="p-flex" *ngIf="displayUnfriendDistance(tracker) != null">
                    <mat-icon color="primary" class="mr-1">logout</mat-icon>
                    <!-- Same underlying field (unfriendDistance) is labeled differently depending on the
                    mode in the config form itself (tracker-config-form.component.html): in easy mode it's
                    the device's only distance setting ("Distance d'alerte"), in advanced mode it's the
                    genuine désappareillage distance alongside the separate min/max alert distances above. -->
                    {{ (displayUserMode(tracker) === 'easy' ? 'units.device.alert_distance' : 'trackers.unfriendDistanceLabel') | translate }} : {{formatDistance(displayUnfriendDistance(tracker))}} m
                </p>
                <!-- Grouped with the other distances rather than the "Ami" section below (even
                though it's stored alongside friendGroup/ignoreGroup - see friendSettings) since
                it reads as one more distance setting, not a friend-group concept. Only shown
                while exclusion mode is on (friendGroup === 99). -->
                <p class="p-flex" *ngIf="displayFriendGroup(tracker) === 99 && displayExclusionDistance(tracker) != null">
                    <mat-icon color="primary" class="mr-1">block</mat-icon>
                    {{'trackers.exclusionDistanceLabel'|translate}} : {{formatDistance(displayExclusionDistance(tracker))}} m
                </p>
            </ng-container>

            <ng-container *ngIf="displayUserMode(tracker) !== 'easy' && hasKydFriendSettings(tracker)">
                <h4 class="p-flex">
                    <mat-icon class="header-icon-card">group</mat-icon>
                    {{'trackers.friend'|translate}}
                </h4>
                <p class="p-flex">
                    <mat-icon>person_add</mat-icon>
                    {{'trackers.friendGroup'|translate}} : {{displayFriendGroup(tracker)}}
                </p>
                <p class="p-flex">
                    <mat-icon>block</mat-icon>
                    {{'trackers.ignoreGroup'|translate}} : {{displayIgnoreGroup(tracker)}}
                </p>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>
    </mat-tab>
</mat-tab-group>
